import React, { useEffect, useRef } from "react"
import { Player, LoadingSpinner, PlayToggle, ControlBar } from 'video-react';

import "../../../../node_modules/video-react/dist/video-react.css"
import './VidWrapper.scss'


const VidWrapperTwo = props => {
  const { 
    src,
    poster,
    returnVideoEl  
  } = props
  
  const videoEl = useRef(null)

  useEffect(() => {
    returnVideoEl(videoEl)
  })

  return(
    <Player
      ref={videoEl}
      playsInline
      autoPlay
      muted
      loop
      preload="auto"
      poster={poster}
    >
      <LoadingSpinner />
      <PlayToggle />
      <ControlBar disableCompletely />
      <source src={src.publicURL} type="video/mp4" />
    </Player>
  )
}

export default VidWrapperTwo